"use client";

import { SafeHydrate } from "@/SafeHydrate";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Calendar } from "lucide-react";
export default function BookingEmbed() {
  const {
    ref: instructionRef,
    isVisible: instructionVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  const {
    ref: widgetRef,
    isVisible: widgetVisible
  } = useRevealOnScroll({
    once: true,
    threshold: 0.2
  });
  return <section id="booking-embed" className="relative bg-background py-16 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-4xl">
        <div ref={instructionRef} className={`mb-8 text-center transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${instructionVisible ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"}`}>
          <p className="text-foreground text-lg font-medium">
            Select your preferred date and time below
          </p>
        </div>

        <div ref={widgetRef} className={`group transition-all duration-[var(--duration-medium)] ease-[var(--ease-smooth)] ${widgetVisible ? "translate-y-0 opacity-100" : "translate-y-5 opacity-0"}`} style={{
        animationDelay: "100ms"
      }}>
          <div className="relative mx-auto max-w-2xl cursor-pointer overflow-hidden rounded-lg border-2 bg-background shadow-soft transition-all duration-[120ms] ease-out hover:-translate-y-0.5 hover:shadow-medium" style={{
          borderColor: "var(--color-accent)"
        }}>
            <div className="aspect-[16/10] bg-muted-light-background p-8">
              <div className="flex h-full flex-col items-center justify-center gap-6">
                <div className="flex size-16 items-center justify-center rounded-full bg-accent/10">
                  <SafeHydrate><Calendar className="size-8" style={{
                    color: "var(--color-accent)"
                  }} /></SafeHydrate>
                </div>
                <div className="text-center">
                  <h3 className="mb-2 text-xl font-semibold text-foreground">
                    Book Your Session
                  </h3>
                  <p className="text-muted-foreground text-sm">
                    Click to open the booking calendar and schedule your appointment
                  </p>
                </div>
                <div className="mt-4 flex items-center gap-2 text-sm text-muted-foreground">
                  <div className="size-2 rounded-full bg-accent"></div>
                  <span>Available slots updated in real-time</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-8 text-center">
          <p className="text-muted-foreground text-sm">
            Need help? Contact us at{" "}
            <span className="font-medium text-accent">
              info@media1pro.com
            </span>
          </p>
        </div>
      </div>
    </section>;
}